import { apiFetch } from "../../lib/utils";

const EndPoint = "/NullReportingComments";

export type NullReportingComment = {
  id: number;
  text: string;
  created: string;
  createdBy: string;
};

const Get = async (orgNr: string, period: string) => {
  const res = await apiFetch(`${EndPoint}/api/${orgNr}/${period}`, "GET");
  if (!res.ok) throw new Error(`Failed to fetch comments: ${res.statusText}`);
  return res.json() as Promise<NullReportingComment[]>;
};

const Create = async (orgNr: string, period: string, text: string) => {
  const res = await apiFetch(
    `${EndPoint}/api/${orgNr}/${period}`,
    "POST",
    JSON.stringify({ text }),
    { "Content-Type": "application/json" }
  );
  if (!res.ok) throw new Error(`Failed to create comment: ${res.statusText}`);
  return res.json();
};

const Update = async (commentId: number, text: string) => {
  const res = await apiFetch(
    `${EndPoint}/api/${commentId}`,
    "PUT",
    JSON.stringify({ text }),
    { "Content-Type": "application/json" }
  );
  if (!res.ok) throw new Error(`Failed to update comment: ${res.statusText}`);
  return res.json();
};

const Delete = async (commentId: number) => {
  const res = await apiFetch(`${EndPoint}/api/${commentId}`, "DELETE");
  if (!res.ok) throw new Error(`Failed to delete comment: ${res.statusText}`);
  return res.json();
};

export const NullReportingComments = { Get, Create, Update, Delete };
